<div class="rp-slider-wrapper">
  <input id="range-ctrl" #rangeControl type="range" min="0" [max]="trackMax" [value]="value" (input)="sliderChange()" />
  <div class="rp-slider-labels">
    <span class="rp-slider-label">{{ oldestRpLabel }}</span>
    <span class="rp-slider-label">{{ newestRpLabel }}</span>
  </div>
</div>
